import React from "react";

import { ChartType as ReportingChart } from "../../pages/ReportAnalytics/pages/Report/store/enums";

//components
import Spacer from "../Spacer";
import Text from "../Text";
//css
import css from "./EmptyChart.module.scss";

//images
const engagementEmptyChartsDir = "/static/img/empty-charts/engagement/";
const reportingEmptyChartsDir = "/static/img/empty-charts/reporting/";

const emptyChartPNGs = {
	// Engagement charts
	radar: `${engagementEmptyChartsDir}radar preview.png`,
	trendline: `${engagementEmptyChartsDir}trendline preview.png`,
	topCohort: `${engagementEmptyChartsDir}top cohort preview.png`,
	participation: `${engagementEmptyChartsDir}participation rate preview.png`,
	scatterSmall: `${engagementEmptyChartsDir}scatter small preview.png`,
	scatterLarge: `${engagementEmptyChartsDir}scatter big preview.png`,
	heatmap: `${engagementEmptyChartsDir}heatmap preview.png`,
	cohortENPS: `${engagementEmptyChartsDir}enps breakdown preview.png`,
	eNPSBreakdown: `${engagementEmptyChartsDir}enps preview.png`,
	// reporting charts
	[ReportingChart.BarChart]: `${reportingEmptyChartsDir}bar chart placeholder.png`,
	[ReportingChart.ColumnChart]: `${reportingEmptyChartsDir}column-chart.png`,
	[ReportingChart.NineBox]: `${reportingEmptyChartsDir}9 box chart placeholder.png`,
	[ReportingChart.ScatterChart]: `${reportingEmptyChartsDir}scatter chart placeholder.png`,
	[ReportingChart.HistogramChart]: `${reportingEmptyChartsDir}distribution chart placeholder.png`,
};

interface EmptyChartProps {
	type:
		| "radar"
		| "trendline"
		| "topCohort"
		| "participation"
		| "scatterSmall"
		| "scatterLarge"
		| "heatmap"
		| "cohortENPS"
		| "eNPSBreakdown"
		| ReportingChart;
}

const EmptyChart = ({ type }: EmptyChartProps) => {
	const isReportingChart = Object.values(ReportingChart).includes(type as ReportingChart);
	const message = isReportingChart
		? "No matching results to display."
		: "We do not have enough data collected to display this chart.";
	return (
		<div className={css.emptyChart}>
			<img
				src={`${emptyChartPNGs[type]}`}
				alt="Empty Chart Type Here"
				height={isReportingChart ? "176px" : "104px"}
			/>
			<Spacer height={2} />
			<Text size="paragraph-1" weight="semi-bold">
				Insufficient Data
			</Text>
			<Spacer height={2} />
			<Text size="paragraph-3" weight="regular" color="neutral-4">
				{message}
			</Text>
		</div>
	);
};

export default EmptyChart;
